import { NextPage } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import React from 'react'

import { getFloatingMenu } from '@/services/apps'
import { getJobList } from '@/services/jobs'
import { getReportHeader } from '@/services/report'
import { wrapper } from '@/store'

import Report from './Report'

const Page: NextPage = () => {
  return (
    <main className='min-h-screen bg-gray-100'>
      <Report />
    </main>
  )
}

export const getProps = wrapper.getServerSideProps((store) => async ({ locale }) => {
  const paramsList = {
    params: { skip: 0, limit: 1000 },
    headers: { 'Accept-Language': String(locale) },
  }
  await Promise.all([
    store.dispatch(getReportHeader.initiate({ headers: { ...paramsList.headers } })),
    store.dispatch(getJobList.initiate(paramsList)),
    store.dispatch(getFloatingMenu.initiate({ headers: { ...paramsList.headers } })),
  ])
  return {
    props: {
      ...(await serverSideTranslations(String(locale), ['common', 'report'])),
    },
  }
})

export default Page
